import axiosInstance from "./axiosInstance";

export const fetchBankVerificationPolicy = async (sourceType) => {
  try {
    const response = await axiosInstance.get("/api/bank-verification/policy", {
      params: sourceType ? { sourceType } : {},
    });
    return {
      success: Boolean(response?.data?.success),
      data: response?.data?.data || {},
      message: response?.data?.message || "Bank verification settings loaded",
    };
  } catch (error) {
    return {
      success: false,
      data: {},
      message:
        error.response?.data?.message ||
        "Unable to load bank verification settings",
    };
  }
};

export const fetchBankVerificationStatus = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/api/bank-verification/status",
      payload,
      { skipGeoBody: true }
    );
    return {
      success: Boolean(response?.data?.success),
      data: response?.data?.data || {},
      message: response?.data?.message || "Bank verification status loaded",
    };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data?.data || {},
      message:
        error.response?.data?.message ||
        "Unable to load bank verification status",
    };
  }
};

export const verifyBankAccount = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/api/bank-verification/verify",
      payload,
      { skipGeoBody: true }
    );
    return {
      success: Boolean(response?.data?.success),
      data: response?.data?.data || {},
      message: response?.data?.message || "Bank verification completed",
    };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data?.data || {},
      message:
        error.response?.data?.message ||
        "Unable to process bank verification",
      status: error.response?.status || 500,
    };
  }
};

export const verifyMatmBankAccount = verifyBankAccount;
